import { combineReducers } from 'redux';
import * as types from '../types';

function uiState(state = { isMenuExpanded: false }, action) {
    switch (action.type) {
        case types.TOGGLE_MENU:
            return Object.assign({}, state, { isMenuExpanded: action.state !== undefined ? action.state : !state.isMenuExpanded });
        default:
            return state;
    }
}

function projects(state = [], action) {
    switch (action.type) {
        case types.ADD_PROJECT:
            return [...state, new Date()];
        default:
            return state;
    }
}

function Alex(state = { counter: 0 }, action) {
    switch (action.type) {
        case 'INCREMENT_ALEX':
            return Object.assign({}, state, { counter: state.counter + 1 });
        default:
            return state
    }
}

export default combineReducers({ projects, Alex, uiState })




// WEBPACK FOOTER //
// ./src/store/reducers/index.js